<script setup lang="ts">
import type { BUTTON_VARIANT } from '@/types/Button';

const {
  loading = false,
  disabled = false,
  block = false,
  outlined = false,
  rounded = undefined,
  size = 'default',
  type = 'submit',
  variant = undefined,
  icon = undefined,
  color = 'primary',
  density = 'default',
} = defineProps<{
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
  outlined?: boolean;
  rounded?: boolean | string | number;
  size?: 'small' | 'default';
  type?: 'submit' | 'button';
  variant?: BUTTON_VARIANT;
  icon?: string | boolean;
  color?: string;
  density?: 'default' | 'comfortable' | 'compact';
}>();

// Get attrs to merge classes
const attrs = useAttrs();
</script>
<template>
  <v-btn
    flat
    :class="['app-btn', attrs.class]"
    :color="color"
    data-cy="submit"
    data-testid="button"
    :type="type"
    :loading="loading"
    :disabled="disabled"
    :size="size"
    :variant="variant"
    :icon="icon"
    :block="block"
    :rounded="rounded"
    :density="density"
  >
    <template #default>
      <slot>
        <v-icon v-if="icon">{{ icon }}</v-icon>
      </slot>
    </template>

    <template #append>
      <slot name="append" />
    </template>
    <template #prepend>
      <slot name="prepend" />
    </template>
  </v-btn>
</template>

<style lang="scss" scoped>
.app-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;

  :deep(.v-btn__content) {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }

  &:disabled,
  &.v-btn--disabled {
    background-color: #b3b3bb !important;
    color: #80808e !important;
    cursor: not-allowed !important;
  }

  &.v-btn--variant-outlined {
    border-color: #414156 !important;
    background-color: white !important;
  }
}
</style>
